export default "__VITE_ASSET__7d8d1d1d__"